import React from 'react';
import { WORKFLOW_STAGES } from '../data/tendersMock';
import './Tenders.css';

/**
 * Visual workflow: Tender Created → Approved → Proposal Prepared → Submitted → Evaluation → Awarded.
 * currentStage: one of WORKFLOW_STAGES (or derived from tender/proposal status).
 */
export default function WorkflowIndicator({ currentStage, className = '' }) {
  const stages = WORKFLOW_STAGES;
  const currentIndex = stages.findIndex((s) => s === currentStage);
  const activeIndex = currentIndex >= 0 ? currentIndex : 0;

  return (
    <div className={`workflow-indicator ${className}`} role="status" aria-label={`Workflow: ${currentStage || 'Unknown'}`}>
      <div className="workflow-steps">
        {stages.map((label, index) => {
          const isActive = index === activeIndex;
          const isPast = index < activeIndex;
          return (
            <React.Fragment key={label}>
              <div className={`workflow-step ${isActive ? 'active' : ''} ${isPast ? 'past' : ''}`}>
                <span className="workflow-step-dot" />
                <span className="workflow-step-label">{label}</span>
              </div>
              {index < stages.length - 1 && (
                <div className={`workflow-connector ${index < activeIndex ? 'past' : ''}`} />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
